import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { ORDERS_PORT } from '@service/preclinical/orders.port';
import { ORDERS_EXPORT_PORT } from '@service/preclinical/orders-export.port';
import { METRICS_PORT } from '@service/preclinical/metrics.port';
import {
  IngestedOrder,
  IngestedOrdersMetrics,
  IngestedOrdersQueryParams
} from '@model/ingested-order/ingested-order.model';
import { FilterOptionsResponse } from '@model/filter/filter-options.model';
import { OrderStatus } from '../../../domain/types/order-status.type';

@Injectable({
  providedIn: 'root'
})
export class IngestedOrdersPresenter {
  private readonly ordersPort = inject(ORDERS_PORT);
  private readonly exportPort = inject(ORDERS_EXPORT_PORT);
  private readonly metricsPort = inject(METRICS_PORT);

  getOrders(params?: IngestedOrdersQueryParams): Observable<{
    orders: IngestedOrder[];
    pagination: {
      page: number;
      size: number;
      total: number;
      totalPages: number;
    };
  }> {
    return this.ordersPort.getOrders(params) as Observable<{
      orders: IngestedOrder[];
      pagination: {
        page: number;
        size: number;
        total: number;
        totalPages: number;
      };
    }>;
  }

  getFilterOptions(): Observable<FilterOptionsResponse> {
    return this.ordersPort.getFilterOptions();
  }

  exportOrders(params?: IngestedOrdersQueryParams): Observable<Blob> {
    return this.exportPort.exportOrders(params);
  }

  getMetrics(): Observable<IngestedOrdersMetrics> {
    return this.metricsPort.getMetrics(OrderStatus.INGRESADA);
  }

  getMetricsStream(intervalMs = 60000): Observable<IngestedOrdersMetrics> {
    return this.metricsPort.getMetricsStream(OrderStatus.INGRESADA, intervalMs);
  }
}
